<template>
  <div
    :loading="mapLoading"
    v-loading="mapLoading"
    element-loading-spinner="qc-spinner"
  >
    <!-- <h4 style="margin-top: 0px">{{ newMapName }}</h4> -->
    <div class="text-center" style="padding-bottom: 10px">
      <button
        @click.prevent="
          mapRegion = 'world';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-btn-fill': mapRegion == 'world' }"
      >
        World</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '150';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-btn-fill': mapRegion == '150' }"
      >
        Europe</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '142';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-btn-fill': mapRegion == '142' }"
      >
        Asia</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '002';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-btn-fill': mapRegion == '002' }"
      >
        Africa</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '019';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-map-btn-fill': mapRegion == '019' }"
      >
        Americas</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '009';
          drawRegionsMap();
        "
        class="btn map-btn"
        :class="{ 'map-map-btn-fill': mapRegion == '009' }"
      >
        Oceania</button
      >&nbsp;
    </div>

    <div id="chart_div" style="height: 67vh"></div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "country-info-map",
  data() {
    return {
      mapName: this.getMapName,
      mapData: null,
      mapRegion: "world",
      mapLoading: false,
      fraudulentCountryMapData: [],
      turnaroundCountryMapData: [],
      options: "",
    };
  },
  created() {
    this.mapName = this.loadMapName;
  },
  mounted() {
    this.mapLoading = true;
    google.charts.load("current", {
      packages: ["geochart", "table"],
      mapsApiKey: "AIzaSyBmBqEYT1PiY0LzhMFE7ENmBYvI8ZSEfXo",
    });
    google.charts.setOnLoadCallback(this.drawRegionsMap);
  },
  methods: {
    drawRegionsMap() {
      var _this = this;
      if (this.mapName.startsWith("Annual Average")) {
        this.mapData = google.visualization.arrayToDataTable(
          this.$store.state.turnaroundCountryMapData
        );
        this.options = {
          backgroundColor: "#ffffff",
          datalessRegionColor: "#F5F5F5",
          sizeAxis: { minValue: 0 },
          colorAxis: {
            values: [0, 0.1, 12, 19, 20],
            colors: ["#F5F5F5", "#4d8ab3", "#a6c4d9", "#c9dce8", "#fd944e"],
          },
          // height: 647,
          region: "world",
          region: _this.mapRegion,
          tooltip: { isHtml: true },
        };
      }
      if (this.mapName.startsWith("Fraudulent")) {
        this.mapData = google.visualization.arrayToDataTable(
          this.$store.state.fraudulentCountryMapData
        );
        this.options = {
          backgroundColor: "#ffffff",
          datalessRegionColor: "#F5F5F5",
          sizeAxis: { minValue: 0 },
          colorAxis: {
            values: [0, 5, 9, 10],
            colors: ["#c9dce8", "#a6c4d9", "#4d8ab3", "#fd944e"],
          },
          // height: 647,
          region: "world",
          region: _this.mapRegion,
          tooltip: { isHtml: true },
        };
      }
      if (this.mapName.startsWith("Current Verification Times")) {
        this.mapData = google.visualization.arrayToDataTable(
          this.$store.state.fiftyPercentMapData
        );
        this.options = {
          backgroundColor: "#ffffff",
          datalessRegionColor: "#F5F5F5",
          sizeAxis: { minValue: 0 },
          colorAxis: {
            values: [0, 0.1, 5, 19, 20],
            colors: ["#F5F5F5", "#4d8ab3", "#a6c4d9", "#c9dce8", "#fd944e"],
          },
          // height: 647,
          region: "world",
          region: _this.mapRegion,
          tooltip: { isHtml: true },
        };
      }
      if (this.mapName.startsWith("Current Number of Institutions")) {
        this.mapData = google.visualization.arrayToDataTable(
          this.$store.state.instituteNumbersMapData
        );
        this.options = {
          backgroundColor: "#ffffff",
          datalessRegionColor: "#F5F5F5",
          sizeAxis: { minValue: 0 },
          colorAxis: {
            values: [0, 0.001, 2000, 6150],
            colors: ["#F5F5F5", "#b8d0e0", "#4d8ab3", "#4d8ab3"],
          },
          // height: 647,
          region: "world",
          region: _this.mapRegion,
          tooltip: { isHtml: true },
        };
      }
      _this.map = new google.visualization.GeoChart(
        document.getElementById("chart_div")
      );

      _this.map.draw(this.mapData, this.options);
      this.mapLoading = false;

      google.visualization.events.addListener(_this.map, "select", function() {
        // BELOW: GETTING SELECTION IDX
        let selectionIdx = _this.map.getSelection()[0].row;
        // BELOW GETTING COUNTRY NAME
        var countryName = _this.mapData.getValue(selectionIdx, 0);
        _this.$store.state.mapSelectedCountry = countryName
      });
      this.$store.state.mapSelectedCountry = null;
        this.$store.state.mapSelectedCountry = _this.$store.state.mapSelectedCountry
    },
  },
  computed: {
    ...mapState(["loadMapName"]),
    ...mapGetters({
      newMapName: "getMapName",
    }),
  },
  watch: {
    newMapName: function(val) {
      this.mapName = val;
      this.drawRegionsMap();
    },
  },
};
</script>
<style>
.google-visualization-tooltip {
  border: solid 1px #4D8AB3 !important;
  border-radius: 6px;
}

.map-btn {
  color: #4D8AB3 !important;
  border-color: #4D8AB3 !important;
}

.map-btn:hover {
  background-color: #4D8AB3 !important;
  color: white !important;
}

.map-map-btn-fill {
  background-color: #4D8AB3 !important;
  color: white !important;
}

.google-visualization-tooltip-item-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}

</style>
